import { useEffect, useState } from 'react';
import "./edi-testing.css";
import LabelModel from '../label-audit-component/labelModel';
import  Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import  Typography from "@mui/material/Typography";

import axios from 'axios';
import Header from '../header-component/mainHeader';
import TestEdiTransComponent from '../test-edi-trans-component/TestEdiTransComponent';
import { useOktaAuth } from '@okta/okta-react';
import { withRouter } from 'react-router';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import LabelAuditComponent from '../label-audit-component/labelAuditComponent';
import FooterComponent from '../footer-component/footerComponent';
import { EDISetupDetails } from "./../edi-setup-details/index";
import NewAs2TradingRelationship from '../as2-onboarding-component/as2-new-trading-relationship/as2-new-trading-relationship';
import UpdateAs2RelationShip from '../as2-onboarding-component/as2-update-relationship/as2-update-relationship';
import SideNav from '../side-nav-component/side-nav';
import AS2CommunicationStatus from '../as2-communication-status-component';
import AS2TradePartnerProfile from "../as2-trade-partner-profiles";
import As2TradePartnersMismatchCACerts from "../as2-tp-mismatch-cacerts";
import TopNavbar from '../top-navbar/top-navbar';
import HomeLanding from '../home-land/homeLand';
import DashboardComponent from '../observability-dashboard-component/DashboardComponent';
import { SupplierTableUpdate } from '../as2-onboarding-component/as2-supplier-table-update/as2-supplier-table-update';
import NotificationsComponent from '../notifications-component/NotificationsComponent';
import { PendingStateProvider } from '../notifications-component/PendingStateContext';
import {DocumentHistory} from "../document-history";
import { configureAmplifyWithOkta } from '../../config/amplify.config';


import TaskQueue from '../partner-manager/TaskQueueView';
import TaskDetail from '../partner-manager/TaskDetailView';

const EDITesting = () => {
    let { path } = useRouteMatch();
    const [ , setTimeAlert] = useState(false);
    const { oktaAuth } = useOktaAuth();
    const [systemError, setSystemError] = useState(false);
    const [supplierList, setSupplierList] = useState([]);
    const [invalidFileName, setInvalidFileName] = useState(false);
    const [invalidFileType, setInvalidFileType] = useState(false);
    const [invalidLabelType, setInvalidLabelType] = useState(false);
    const [processingTime, setProcessingTime] = useState(null);
    const [showInvalidlabel, setShowInvalidlabel] = useState(false);
    const [shipmentAlert, setShipmentAlert] = useState(false);
    const [labelIsNotValid, setlabelIsNotValid] = useState(null);
    const [oktaDetails, setOktaDetails] = useState({});
    const [userId, setUserId] = useState("");

    const handleKeyDown = (e) => {
        //for John Deere internal Employee, needs to submit atleast 4 digits
        if (e.target.value.length >= 3) {
            oktaDetails.usertype !== "Supplier Employee" &&
                axios.get(process.env.REACT_APP_API_BASE_URL + "/getSupplierInfoEmployee?queryString=" + e.target.value,
                    {
                        params: {
                            _limit: 5
                        },
                        headers: {
                            'Authorization': 'Bearer ' + oktaAuth.getAccessToken()
                        }
                    })
                    .then((response) => {
                        const filteredResponse = response.data.map(item => item.supplierNumber + " - " + item.supplierName);
                        setSupplierList(filteredResponse);
                    })
                    .catch((error) => {
                        setSystemError(true);
                    })
        }
    }
    useEffect(() => {
        async function initMainComponent() {
            const userDetails  = await getUserDetails(); // Important - Use return object, state is not updated instantly
            if (userDetails.usertype === "Supplier Employee") {
                await populateRelatedSuppliers(userDetails.userid);
            }
        }

        async function getUserDetails() {
            //gets user details after login
            const { name, userID, userType, email, EDISupplierSelfServiceAdminGroup, GTLSUPPORTGroup, EDIAdGroups} = await oktaAuth.getUser();
            console.log(oktaAuth.getUser());
            const userDetails = {
                username: name,
                userid: userID,
                usertype: userType,
                useremail: email,
                ediItAdmin: EDIAdGroups ? true : false,
                supplierNumber: EDIAdGroups ? "0000001111" : null,
                ediCoordinator: (!EDIAdGroups && EDISupplierSelfServiceAdminGroup),
                deereStakeholder: (!EDIAdGroups && !EDISupplierSelfServiceAdminGroup && !GTLSUPPORTGroup && userType !== 'Supplier Employee'),
                supplierAccess: (userType === 'Supplier Employee') ? true : false,
                gtlSupport: (GTLSUPPORTGroup && !EDIAdGroups && !EDISupplierSelfServiceAdminGroup),
            }

            setUserId(userID)
            setOktaDetails(userDetails);
            return userDetails;
        }

        const populateRelatedSuppliers = async (userId) => {
            try {
                // Get all suppliers for this user
                const supplierIdsResponse = await axios.get(
                    process.env.REACT_APP_API_BASE_URL + "/getSupplierInfoSupplier?queryString=" + userId,
                    {
                        headers: {
                            'Authorization': 'Bearer ' + oktaAuth.getAccessToken()
                        }
                    }
                );

                const supplierIds = supplierIdsResponse.data; // ["0000329141", ...]
                //Uncomment for testing user with multiple suppliers
                // const supplierIds = ["0000329141", "0000002666"]

                // Get supplier information for each supplier ID
                const supplierInfoPromises = supplierIds.map(id =>
                    axios.get(
                        process.env.REACT_APP_API_BASE_URL + "/getSupplierInfoEmployee",
                        {
                            params: {
                                queryString: id,
                                _limit: 5
                            },
                            headers: {
                                'Authorization': 'Bearer ' + oktaAuth.getAccessToken()
                            }
                        }
                    )
                );

                const supplierInfoResponses = await Promise.all(supplierInfoPromises);
                //Format the supplier list to look like ['0000329141 - SPECIALTY RESOURCES INC', ...]
                const allSuppliers = supplierInfoResponses.flatMap(response =>
                    response.data.map(item => `${item.supplierNumber} - ${item.supplierName}`)
                );

                console.log("Related Suppliers:", allSuppliers);
                setSupplierList(allSuppliers);
            } catch (error) {
                console.error("Error fetching related suppliers:", error);
                setSystemError(true);
            }
        };

        initMainComponent();
    }, []);

    const minute_ms = 10000;

    useEffect(() => {
        //trigger for "System Error" alert
        const interval = setInterval(() => {
            if (systemError)
                setSystemError(false);
            if (invalidFileType)
                setInvalidFileType(false);
            if (invalidFileName)
                setInvalidFileName(false);
            if (invalidLabelType)
                setInvalidLabelType(false);
        }, minute_ms);

        return () => clearInterval(interval);
    }, [systemError, invalidFileType, invalidFileName, invalidLabelType])

    const refreshHandler = (event) => {
        setShowInvalidlabel(false);
        window.location.reload();
    }

    useEffect(() => {
            if (oktaAuth) {
                try {
                    configureAmplifyWithOkta(oktaAuth);
                } catch (error) {
                    console.error('Failed to configure Amplify:', error);
                }
            }
        }, [oktaAuth]);

    return (
        <div className="containerbody">
            <Header userName={oktaDetails.username} userType={oktaDetails.usertype}/>
            <PendingStateProvider>
            <div style={{display:'flex', width:'100%'}}>
            <TopNavbar userType={oktaDetails.userType} setSupplierList={oktaDetails.setSupplierList} ediItAdmin={oktaDetails.ediItAdmin} gtlSupport={oktaDetails.gtlSupport} ediCoordnatorAccess={oktaDetails.ediCoordinator}
            supplierAccess={oktaDetails.supplierAccess} stakeholderAccess={oktaDetails.deereStakeholder}/>
            <div className="edi-container" style={{ minHeight: 'calc(106vh - 13.1rem)' }}>
                {systemError && <Alert severity="warning">
                    {"Something Went Wrong. Please Contact Administrator."}
                </Alert>
                }
                {/*To show popup */}

                <Switch>
                    <Route path={`${path}/Landing`}>
                        <HomeLanding userId={userId}/>
                    </Route>
                    <Route path={`${path}/ediTesting`}>
                        {invalidFileType && <Alert className="alertTop" severity="warning">
                            {"File type must be .txt or .edi"}
                        </Alert>
                        }
                        {shipmentAlert &&
                            <Alert className="alertTop" severity="warning">
                                {"Select one shipment type to proceed with testing"}
                            </Alert>
                        }
                        {invalidFileName && <Alert className="alertTop" severity="warning" >
                            {"File name need to be 30 characters or less"}
                        </Alert>
                        }
                        <Typography gutterBottom variant="h1" component="h1">
                            Automated Testing
                        </Typography>

                        <Card className="p-4">
                            <TestEdiTransComponent
                                invalidFileName={invalidFileName}
                                invalidFileType={invalidFileType}
                                setInvalidFileName={setInvalidFileName}
                                setInvalidFileType={setInvalidFileType}
                                setTimeAlert={setTimeAlert}
                                setProcessingTime={setProcessingTime}
                                processingTime={processingTime}
                                setSystemError={setSystemError}
                                useremail={oktaDetails.useremail}
                                username={oktaDetails.username}
                                userid={oktaDetails.userid}
                                handleKeyDown={handleKeyDown}
                                usertype={oktaDetails.usertype}
                                refreshHandler={refreshHandler}
                                supplierList={supplierList}
                                setShipmentAlert={setShipmentAlert}
                            >

                            </TestEdiTransComponent>
                        </Card>
                    </Route>
                    <Route path={`${path}/labelAudit`}>
                        <LabelModel showInvalid={showInvalidlabel} refreshHandler={refreshHandler} labelIsNotValid={labelIsNotValid} />
                        {invalidLabelType && <Alert variant="warning" >
                            {"File type must be .pdf, .jpg, .png or .bmp"}
                        </Alert>
                        }

                        <Typography gutterBottom variant="h1" component="h1">
                            Label Compliance
                        </Typography>
                        <div className="guideliness">
                            <Alert severity="info"  >
                                <Typography variant="button" display="block" gutterBottom>If you need help, please refer to the Guidelines and Standards:
                                <Button variant="text" > <a target="_blank" rel="noopener noreferrer" href={process.env.REACT_APP_LABELS_STANDARD_GUIDELINES_LINK}>
                                    John Deere Global Transport Labels (GTL) for Direct Materials.</a>
                                </Button></Typography>
                            </Alert>
                        </div>

                        <LabelAuditComponent
                            invalidFileName={invalidFileName}
                            invalidFileType={invalidFileType}
                            setInvalidFileName={setInvalidFileName}
                            setInvalidFileType={setInvalidFileType}
                            usertype={oktaDetails.usertype}
                            supplierList={supplierList}
                            handleKeyDown={handleKeyDown}
                            setTimeAlert={setTimeAlert}
                            setSystemError={setSystemError}
                            refreshHandler={refreshHandler}
                            setProcessingTime={setProcessingTime}
                            processingTime={processingTime}
                            useremail={oktaDetails.useremail}
                            username={oktaDetails.username}
                            setShowInvalidlabel={setShowInvalidlabel}
                            userid={oktaDetails.userid}
                        >
                        </LabelAuditComponent>

                    </Route>

                    <ProtectedRoute path={`${path}/ediSetupDetails`}
                        isAllowAdmin={oktaDetails.ediItAdmin || oktaDetails.ediCoordinator || oktaDetails.deereStakeholder || oktaDetails.gtlSupport}>
                        <EDISetupDetails />
                    </ProtectedRoute>

                    <Route path={`${path}/as2CommunicationStatus`}>
                        <AS2CommunicationStatus />
                    </Route>

                    <ProtectedRoute path={`${path}/observability`}
                        isAllowAdmin={oktaDetails.ediItAdmin || oktaDetails.ediCoordinator}>
                        <DashboardComponent/>
                    </ProtectedRoute>

                    {/* <Route path={`${path}/as2TradingPartnerProfiles`}>
                        <AS2TradePartnerProfile />
                    </Route> */}

                    {/* <Route path={`${path}/as2TPMismatchCACerts`}>
                        <As2TradePartnersMismatchCACerts />
                    </Route> */}



                    {/* New Routes for the AS2 component */}

                    <ProtectedRoute path={`${path}/newAs2TradingRelationship`}
                        isAllowAdmin={oktaDetails.ediItAdmin || oktaDetails.ediCoordinator}>
                        <NewAs2TradingRelationship
                            usertype={oktaDetails.usertype}
                            userid={oktaDetails.userid}
                            userEmail={oktaDetails.useremail}
                        />
                    </ProtectedRoute>

                    <ProtectedRoute path={`${path}/updateAs2Relationship`}
                        isAllowAdmin={oktaDetails.ediItAdmin || oktaDetails.ediCoordinator}>
                        <UpdateAs2RelationShip
                            userEmail={oktaDetails.useremail}
                        />
                    </ProtectedRoute>

                    <ProtectedRoute path={`${path}/supplierUpdate`}
                        isAllowAdmin={oktaDetails.ediItAdmin || oktaDetails.ediCoordinator}>
                        <SupplierTableUpdate
                        usertype={oktaDetails.usertype}
                        handleKeyDown={handleKeyDown}
                        supplierList={supplierList}
                        setSystemError={setSystemError}
                        >
                        </SupplierTableUpdate>
                    </ProtectedRoute>

                    <ProtectedRoute path={`${path}/Admin`}
                        isAllowAdmin={(oktaDetails.ediItAdmin || oktaDetails.ediCoordinator)}>
                        <SideNav
                            usertype={oktaDetails.usertype}
                            username={oktaDetails.username}
                            supplierList={supplierList}
                            userid={oktaDetails.userid}
                            handleKeyDown={handleKeyDown}
                        />
                    </ProtectedRoute>

                    <ProtectedRoute path={`${path}/Notifications`}
                        isAllowAdmin={oktaDetails.supplierAccess || oktaDetails.ediItAdmin || oktaDetails.ediCoordinator}>
                            <Typography gutterBottom variant="h1" component="h1">
                                Notification name
                            </Typography>
                                <NotificationsComponent
                                    supplierList={supplierList}
                                    handleKeyDown={handleKeyDown}
                                    userType={oktaDetails.usertype}
                                />
                    </ProtectedRoute>

                    <ProtectedRoute path={`${path}/taskDetail/:routeKey/:taskId`}
                        isAllowAdmin={oktaDetails.ediItAdmin || oktaDetails.ediCoordinator}>
                        <TaskDetail />
                    </ProtectedRoute>

                    <ProtectedRoute path={`${path}/taskQueue`}
                        isAllowAdmin={oktaDetails.ediItAdmin || oktaDetails.ediCoordinator}>
                        <TaskQueue />
                    </ProtectedRoute>


{/*                     <ProtectedRoute path={`${path}/documentHistory`}
                                    isAllowAdmin={oktaDetails.supplierAccess || oktaDetails.ediItAdmin || oktaDetails.ediCoordinator}>
                       <DocumentHistory/>
                    </ProtectedRoute> */}


                    <Route path={`${path}/`} >
                      <Redirect to={`${path}/Landing`} />
                    </Route>
                </Switch>
            </div>
            </div>
            </PendingStateProvider>
            <FooterComponent />
        </div>
    )
}

const ProtectedRoute = ({ children, ...rest }) => {
    let { path } = useRouteMatch();
    const {isAllowAdmin} = rest
    return (
        <Route {...rest} render={() => {
            if(isAllowAdmin !== undefined){
                console.log("Access: ", isAllowAdmin)
                return isAllowAdmin ? (children) : <Redirect to={`${path}/`}/>;
            }
        }}/>);
}

export default withRouter(EDITesting);
